import AttributeSelect from './attributeSelect.container';
export default AttributeSelect